import { render, staticRenderFns } from "./VerificationInfo.vue?vue&type=template&id=7e1d2b8f"
import script from "./VerificationInfo.vue?vue&type=script&lang=js"
export * from "./VerificationInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports